import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    // Options -----
    this.count = this.el.getAttribute('data-count')
      ? Number.parseInt(this.el.getAttribute('data-count'))
      : null
    this.url = this.el.getAttribute('data-folder')
      ? this.el.getAttribute('data-folder')
      : null
    this.pad = this.el.getAttribute('data-pad')
      ? Number.parseInt(this.el.getAttribute('data-pad'))
      : 3
    this.extension = this.el.getAttribute('data-extension')
      ? this.el.getAttribute('data-extension')
      : '.avif'
    this.hasHover = this.el.hasAttribute('data-hover')
    this.hasPreload = this.el.hasAttribute('data-preload')
    // -------------

    this.images = []
    this.img = new Image()

    this.currentIndex = 0

    this.context = null
    this.canvas = this.createCanvas()

    if (this.hasPreload) {
      this.preload()
    }

    if (this.hasHover) {
      this.initHover()
    }

    this.handleResize = this.handleResize.bind(this)
    this.hoverMove = this.hoverMove.bind(this)

    window.addEventListener('resize', this.handleResize)
  }

  init() {
    // Load and draw first image
    this.img.src = this.getImageUrl(0)
    this.images.push(this.img)
    this.img.onload = () => {
      this.render(0)
    }
  }

  createCanvas() {
    const canvas = document.createElement('canvas')

    this.context = canvas.getContext('2d')
    canvas.width = this.el.offsetWidth
    canvas.height = this.el.offsetHeight

    const canvasWidth = canvas.width
    const canvasHeight = canvas.height

    canvas.width = canvasWidth * window.devicePixelRatio
    canvas.height = canvasHeight * window.devicePixelRatio
    canvas.style.width = `${canvasWidth}px`
    canvas.style.height = `${canvasHeight}px`

    this.context.scale(window.devicePixelRatio, window.devicePixelRatio)

    this.el.appendChild(canvas)

    return canvas
  }

  getImageUrl(index) {
    return this.url + index.toString().padStart(this.pad, '0') + this.extension
  }

  preload() {
    let img

    this.images = []

    for (let index = 0; index < this.count; index++) {
      img = new Image()
      img.src = this.getImageUrl(index)
      this.images.push(img)
    }
  }

  setProgress(progress = 0) {
    const newIndex = Math.max(0, Math.min(this.count - 1, Math.ceil(progress * this.count)))

    if (newIndex !== this.currentIndex) {
      this.currentIndex = newIndex
      this.render()
    }
  }

  render(index = this.currentIndex) {
    const img = this.images[index]

    if (!img)
      return

    const imgRatio = img.height / img.width
    const parentRatio = this.el.offsetHeight / this.el.offsetWidth

    this.context.clearRect(
      0,
      0,
      this.canvas.width,
      this.canvas.height
    )

    if (imgRatio > parentRatio) {
      const h = this.el.offsetWidth * imgRatio

      this.context.drawImage(
        img,
        0,
        (this.el.offsetHeight - h) / 2,
        this.el.offsetWidth,
        h
      )
    }
    if (imgRatio < parentRatio) {
      const w = this.el.offsetWidth * parentRatio / imgRatio

      this.context.drawImage(
        img,
        (this.el.offsetWidth - w) / 2,
        0,
        w,
        this.el.offsetHeight
      )
    }
  }

  initHover() {
    this.el.addEventListener(
      'mousemove',
      this.hoverMove,
      { passive: true }
    )
  }

  hoverMove(e) {
    const target = e.target
    const rect = target.getBoundingClientRect()
    const x = e.clientX - rect.left

    this.setProgress(x / rect.width)
  }

  handleResize() {
    this.canvas.width = this.el.offsetWidth
    this.canvas.height = this.el.offsetHeight
    this.canvas.style.width = `${this.el.offsetWidth}px`
    this.canvas.style.height = `${this.el.offsetHeight}px`

    this.render()
  }

  destroy() {
    window.removeEventListener('resize', this.handleResize)
    this.el.removeEventListener('mousemove', this.hoverMove)
    this.imgs = []

    this.context.reset?.()
  }
}
